<template>
  <div>
    <Head title="Atendimentos para usuários B2B" />
    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
        Configuração de Atendimentos para usuários B2B
      </h1>
      <data-table
        v-if="loadTable"
        search-label="Pesquisar por nome ou especialidade"
        v-model:columns="columns"
        route="seetings-services-b2b/list"
        no-data-label="Nenhuma configuração cadastrada"
        no-result-label="Nenhuma configuração encontrada"
      >
        <template #table.cell.content.seeting_status="{ value, row }">
          <div v-if="row.status">Ativo</div>
          <div v-if="!row.status">Inativo</div>
          <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
        </template>
        <template #grid.content.body.seeting_status="{ value, row }">
          <div v-if="row.status">Ativo</div>
          <div v-if="!row.status">Inativo</div>
          <!-- switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo" @click="changeStatus(row)" /-->
        </template>

        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-3 gap-4">
            <Link :href="'/seetings-services-specialties/' + row.id" class="flex">
              <span><font-awesome-icon icon="fa-suitcase-medical" class="text-primary text-lg cursor-pointer" /></span>
          </Link>
            <span @click="openModalEdit(row)"
              ><font-awesome-icon
                icon="fa-pen-to-square"
                class="text-primary text-lg cursor-pointer"
            /></span>
            <span @click="openModalConfirmDelete(row)"
              ><font-awesome-icon
                icon="fa-trash-can"
                class="text-red-600 text-lg cursor-pointer"
            /></span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-3 gap-4">
            <Link :href="'/seetings-services-specialties/' + row.id" class="flex">
              <span><font-awesome-icon icon="fa-suitcase-medical" class="text-primary text-lg cursor-pointer" /></span>
          </Link>
            <span @click="openModalEdit(row)"
              ><font-awesome-icon
                icon="fa-pen-to-square"
                class="text-primary text-lg cursor-pointer"
            /></span>
            <span @click="openModalConfirmDelete(row)"
              ><font-awesome-icon
                icon="fa-trash-can"
                class="text-red-600 text-lg cursor-pointer"
            /></span>
          </div>
        </template>

        <template #after.reload-button>
          <button
            class="flex justify-center items-end font-roboto font-medium btn-primary uppercase w-full"
            @click.prevent="openModalEdit({})"
          >
            <font-awesome-icon
              icon="fa-plus"
              class="text-white text-lg mr-2"
            /><span class=""> Adicionar Configuração</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit
      :modal-scrollable="true"
      ref="modalEdit"
      title="Configuração"
      url="seetings-services-b2b"
      @submitForm="reloadTable"
      :item="{ user: {}, group: null, specialty: null, errors: { user: {} } }"
      :multipart="true"
    >
      <template #form="{ item }">
        <div class="hidden lg:block lg:w-1/2"></div>
        <text-input
          v-model="item.name"
          :error="item.errors[`name`]"
          class="lg:pr-6 mt-6 w-full lg:w-2/3"
          label="Configuração"
        />
        <switch-input
          v-model="item.status"
          class="mt-6 w-full lg:w-1/3"
          label="Situação"
          labelChecked="Ativo"
          labelUnchecked="Inativo"
        />
        <select-input
          v-model="item.company_id"
          class="mt-6 lg:pr-6 w-full"
          label="Empresa"
        >
          <option :value="null">Todas</option>
          <option
            v-for="(value, name, index) in companies_options"
            :key="value.name"
            :value="value.id"
          >
            {{ value.name }}
          </option>
        </select-input>
        
        
      </template>
    </modal-edit>
  </div>
</template>
  
<script>
import { computed } from "vue";
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "@/Shared/Layout/Layout";
import LoadingButton from "@/Shared/Components/LoadingButton";
import ModalDelete from "@/Shared/Modal/ModalDelete";
import ModalEdit from "@/Shared/Modal/ModalEdit";
import Modal from "@/Shared/Modal/Modal";
import DataTable from "@/Shared/Components/DataTable";
import SwitchInput from "@/Shared/Fields/SwitchInput";
import TextInput from "@/Shared/Fields/TextInput";
import EmailInput from "@/Shared/Fields/EmailInput";
import TextareaInput from "@/Shared/Fields/TextareaInput";
import PasswordInput from "@/Shared/Fields/PasswordInput";
import SelectInput from "@/Shared/Fields/SelectInput";
import MaskInput from "@/Shared/Fields/MaskInput";
import VueSelectInput from "@/Shared/Fields/VueSelectInput";
import PhotoInput from '@/Shared/Fields/PhotoInput';
import CepInput from "@/Shared/Fields/CepInput";
import PercentualInput from "@/Shared/Fields/PercentualInput";
import DateInput from "@/Shared/Fields/DateInput";

export default {
  props: {
    specialties_options: Object,
    companies_options: Object,
  },
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    Modal,
    DataTable,
    SwitchInput,
    TextInput,
    EmailInput,
    PasswordInput,
    SelectInput,
    MaskInput,
    VueSelectInput,
    TextareaInput,
    PhotoInput,
    CepInput,
    PercentualInput,
    DateInput,
    Link,
  },
  layout: Layout,
  mounted() {},
  setup() {},
  data() {
    return {
      specialties_options_aux: [],
      seeting_service_specialties_aux: [],

      loadTable: true,
      columns: [
        {
          uniqid: "seeting_name",
          label: "Configuração",
          field: "name",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes: "px-4 py-3 border-b text-sm",
          headerClass: "p-4 text-left",
          format: (val, row) => `${row.name}`,
        },
        {
          uniqid: "seeting_status",
          label: "Situação",
          field: "status",
          visible: true,
          sortable: true,
          sortOrder: "asc",
          classes:
            "px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis",
          headerClass: "p-4 text-left",
        },
        {
          uniqid: "actions",
          label: "Ações",
          field: "id",
          visible: true,
          align: "center",
          classes: "py-3 border-b",
          headerClass: "p-4",
        },
      ],
    };
  },
  methods: {
    changeStatus(item) {
      item.status = !item.status;
      this.$inertia.post("/seetings-services-b2b/update-status", {
        id: item.id,
        status: item.status,
      });
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(
        item,
        `/seetings-services-b2b/${item.id}`,
        `Deseja realmente excluir a configuração ${item.name}?`
      );
    },
    
    async deletar(seetingServiceSpecialty) {
      await fetch(
        `/seetings-services-b2b/delete-specialty/` + seetingServiceSpecialty.id
      ).then((res) => {
        res.json().then((json) => {
          this.sucess = json.sucess;
        });
      });
    },
    openModalEdit(i) {
      
      


      let item = {
        id: i.id,
        name: i.name,
        status: i.status ?? true,
        company_id: i.company_id ?? null,
        
        


      };
      

      this.$refs.modalEdit.openModalEdit(item);
    },
    
    
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => (this.loadTable = true), 10);
    },
  },
};
</script>